import React, { ReactElement } from 'react';
import { Immutable } from '@wds/utils';
import { List } from '@wds/list';

export type SubMenuItemProps = Immutable<{
  title?: string;
  name?: string;
  path?: string;
  url?: string;
  openInNewWindow?: boolean;
  show?: boolean;
}>;

export const SubMenuItem = ({
  title = '',
  name = '',
  path = '',
  url = '',
  openInNewWindow = false,
  show = true,
}: SubMenuItemProps): ReactElement | null => {
  const itemTitle = name || title;
  const itemURL = path || url;

  if (!itemTitle || !itemURL || !show) return null;

  return (
    <List.Item
      key={itemTitle}
      isNavigable
      navigationTarget={itemURL}
      {...(openInNewWindow === true && {
        target: '_blank',
        rel: 'noopener noreferrer',
      })}
    >
      {itemTitle}
    </List.Item>
  );
};

export default SubMenuItem;
